import { Component, Input } from '@angular/core';

import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrl: './delete-modal.component.scss',
})
export class DeleteModalComponent {
  @Input() header = $localize`Delete`;
  @Input() message = $localize`Are you sure you want to delete this item?`;

  constructor(private modalService: ModalService) {}

  onDelete() {
    this.modalService.close();
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
